import Button, { ButtonType } from "../../components/Button/Button";
import { FetchedOrderUploadProduct } from "./types";
import { sortProducts } from "./utils/productUtils";
import CartItemTable from "../../components/CartItemTable/CartItemTable";
import Accordion from "../../components/Accordion/Accordion";
import { useOrderUploaderContext } from "./context/OrderUploaderContext";
import { productErrorCode } from "./utils/data";

const ImportTable = () => {
  const {
    fetchedProducts: products,
    handleRemoveItem: removeFetchedItem,
    handleReloadItem: reloadItemDetails,
  } = useOrderUploaderContext();
  const sortedProducts = sortProducts(products);
  const invalidProducts = sortedProducts.filter(
    (product: FetchedOrderUploadProduct) => !product.price || !product.itemNo,
  );
  const validProducts = sortProducts(
    sortedProducts.filter((product: FetchedOrderUploadProduct) => product.price && product.itemNo),
    {
      ascending: true,
      type: "index",
    },
  );
  const importedLabel = validProducts.length === 1 ? "item" : "items";
  const unimportedLabel = invalidProducts.length === 1 ? "item" : "items";

  return (
    <div className="import-table-container">
      {invalidProducts.length > 0 && (
        <Accordion
          title={`Unimported Items (${invalidProducts.length} ${unimportedLabel})`}
          expanded
        >
          <table className="import-table">
            <tbody>
              {invalidProducts.map((product, index: number) => (
                <tr key={index} className="reload-order-item cart-item">
                  <td className="button-cell">
                    <Button
                      type={ButtonType.danger}
                      onClick={() => removeFetchedItem(product.csvLineArray[0])}
                    >
                      Remove
                    </Button>
                    <span>or</span>
                    <Button
                      type={ButtonType.secondary}
                      onClick={() => reloadItemDetails(product.csvLineArray[0])}
                    >
                      Reload
                    </Button>
                  </td>
                  <td>SKU: {product.csvLineArray[0]}</td>
                  <td>
                    {product.product_code &&
                      product.product_name &&
                      `Item: ${product.product_code} | Name: ${product.product_name}`}
                  </td>
                  {product.error_code && <td>Reason: {productErrorCode[product.error_code]}</td>}
                </tr>
              ))}
            </tbody>
          </table>
        </Accordion>
      )}
      <Accordion title={`Imported Items (${validProducts.length} ${importedLabel})`} alwaysOpen>
        <CartItemTable items={validProducts} disableAvailableQty disableTotal qtyColumn />
      </Accordion>
    </div>
  );
};

export default ImportTable;
